// @ts-check
/* eslint-env browser */
import { reactiveStore } from '../../../reactive-store.js'

export class MoveWithToggle extends HTMLElement {
  connectedCallback () {
    this.input = /** @type {HTMLInputElement | null} */ (this.querySelector('input[type="checkbox"]'))
    this.input?.addEventListener('change', this.#update)
  }

  #update = () => {
    if (!this.input) return
    const moveWith = this.input.checked
    const current = reactiveStore.overlayMaps.get()

    reactiveStore.overlayMaps.set(
      current.map((entry) => {
        if (entry.storagePath === this.dataset.storagePath) {
          return { ...entry, moveWith }
        }
        return entry
      })
    )
  }
}

customElements.define('move-with-toggle', MoveWithToggle)
